import { makeStyles } from '@material-ui/core/styles';
import { IUserToken } from 'interfaces/userToken';
import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import rxjsOperators from 'rxjs-operators';
import authService from 'services/auth';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';

import DropdownMenu from 'components/Shared/DropdownMenu';
import ExitToAppIcon from 'mdi-react/ExitToAppIcon';
import KeyVariantIcon from 'mdi-react/KeyVariantIcon';
import { DrawerContext } from '.';
import { ReactComponent as UserIcon } from 'assets/icons/menu/usuario.svg';

interface IProps {
  user: IUserToken;
  classes?: any;
}

const useStyles = makeStyles(theme => ({
  root: {
    textAlign: 'left',
    color: theme.palette.primary.main,
    width: '100%'
  },
  icon: {
    paddingRight: '6px',
    marginRight: '6px',
  },
  textSmall: {
    display: 'block',
    marginBottom: '2px'
  }
}));

const AppDrawerUser = (props: IProps) => {
  const { user } = props;
  const classes = useStyles();
  const drawerContext = useContext(DrawerContext);
  const history = useHistory();

  const handleChangePassword = () => {
    authService.openChangePassword();
  };

  const handleLogout = () => {
    drawerContext.close();
    authService.logout(false).pipe(
      rxjsOperators.logError()
    ).subscribe(() => {
      history.push('/');
    });
  };

  if (!user) {
    return null;
  }

  return (
    <List>
      <ListItem onClick={() => { }}>
        <ListItemIcon>
          <UserIcon width={28} viewBox="0" className={classes.icon} />
        </ListItemIcon>
        <ListItemText
          primary={user.firstName}
          primaryTypographyProps={{ variant: 'subtitle1', align: 'left' }}
        />
        <ListItemSecondaryAction>
          <DropdownMenu options={[{
            text: 'Trocar senha',
            icon: KeyVariantIcon,
            handler: handleChangePassword
          }, {
            text: 'Sair',
            icon: ExitToAppIcon,
            handler: handleLogout
          }]} />
        </ListItemSecondaryAction>
      </ListItem>
    </List>
  );
};

export default AppDrawerUser;